import React from "react";

const Back = ({ onClick }) => {
  return (
    <div>
      <div className="row mb-4 justify-content-end">
        <div className="col-md-3 d-flex justify-content-end">
          <button className="btn btn-outline-warning px-4" onClick={onClick}>
            <i class="fa-solid fa-backward"></i> Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default Back;
